import lozad from 'lozad'

export default function (Glide, Components, Events) {
  const Lazy = {
    mounted () {
      this.observer =
        lozad(Glide.settings.lazyGlide.selector, {
          root: Components.Html.wrapper,
          loaded: (e) => {
            this.loaded(e)
          }
        })

      this.observer.observe()
    },
    run () {
      const slide = Components.Html.slides[Glide.index]
      slide.classList.add(Glide.settings.lazyGlide.wokenSlide)
      this.observer.observe()
    },
    loaded (e) {
      Events.emit('resize')
    },
    observe () {
    }
  }

  Glide.settings.lazyGlide =
    Object.assign(
      {
        selector: '.lazy',
        wokenSlide: 'glide__slide--woken'
      },
      Glide.settings.lazyGlide
    )

  Events.on('mount.after', () => { Lazy.mounted() })
  Events.on('run.after', () => { Lazy.run() })

  return Lazy
}
